enum ConstituentSearchColumn {
  AVATAR = 'avatar',
  DISPLAY_NAME = 'display_name',
  DEVELOPERS = 'developers',
  CONSTITUENT_RULES = 'constituent_rules',
  CONSTITUENT_CATEGORIES = 'constituent_categories',
  LAST_INTERACTION_DATE = 'last_interaction_date',
  PRIMARY_PHONE = 'primary_phone',
  BIO = 'biography',
  LABELS = 'labels',
  PRIMARY_EMAIL = 'primary_email',
  PRIMARY_CITY = 'primary_city',
  PRIMARY_STATE = 'primary_state',
  PRIMARY_COUNTRY = 'primary_country',
  INSTAGRAM = 'instagram',
  TWITTER = 'twitter',
  LINKEDIN = 'linkedin',
  FACEBOOK = 'facebook',
  YOUTUBE = 'youtube',
  TIKTOK = 'tiktok',
  LIFETIME_COUNT = 'lifetime_count',
  LIFETIME_DONATIONS = 'lifetime_donations',
  LIFETIME_HOURS = 'lifetime_hours',
  THIS_YEAR_COUNT = 'this_year_count',
  THIS_YEAR_DONATIONS = 'this_year_donations',
  THIS_YEAR_HOURS = 'this_year_hours',
  NUM_CONNECTIONS = 'num_connections',
  CUSTOM_FIELDS = 'custom_fields',
  IS_DECEASED = 'is_deceased',
  DATE_OF_BIRTH = 'dob',
  INCOMPLETE_TASKS = 'incomplete_tasks',
}

export default ConstituentSearchColumn;
